import React, { useMemo } from 'react'
import { FieldArray, useFormikContext } from 'formik'
import { v4 } from 'uuid'

import { PortrayalFormInProgressState, SearchType } from './types'

import {
    FormikCharacterSearchAsCharacter,
    InlineCharacterSearchAsCharacter,
} from './CharacterSearch'
import { FormikTalentSearchAsCharacter, InlineTalentSearchAsCharacter } from './TalentSearch'
import { getPortraysSearchTypeFromPortrayalType } from './utils'
import { usePortrayalsContext } from './portrayalRowsContext'
import Text from 'shared/components/Text'
import { MdmIdGrid } from './Layout'
import { MdmSearchModeCtrl } from './MdmIDSearchModeCheckbox'

export const FormikPortrays: React.FC<{
    disabled: boolean
    onSearchModeChange: (value: boolean) => void
    isMdmSearchModeOn: boolean
}> = ({ disabled, isMdmSearchModeOn, onSearchModeChange }) => {
    const { values } = useFormikContext<PortrayalFormInProgressState>()

    const searchType = useMemo(() => {
        return getPortraysSearchTypeFromPortrayalType(values.portrayal.portrayalType?.uri || '')
    }, [values.portrayal.portrayalType])

    return (
        <>
            <MdmIdGrid disabled={disabled}>
                <Text size="5" weight="bold" as="h5">
                    Portrays
                </Text>
                <Text size="5" weight="bold" as="h5">
                    MDM ID
                </Text>
            </MdmIdGrid>
            <FieldArray name="portrays">
                {() => (
                    <>
                        {values.portrays.map((_, idx) => {
                            const name = `portrays[${idx}]`
                            return (
                                <div
                                    key={v4()}
                                    style={{
                                        marginBottom:
                                            idx === values.portrays.length - 1 ? 'auto' : '0.5rem',
                                    }}
                                >
                                    {searchType === SearchType.Character ? (
                                        <FormikCharacterSearchAsCharacter
                                            disabled={disabled}
                                            name={name}
                                            index={idx}
                                            isMdmMode={isMdmSearchModeOn}
                                        />
                                    ) : (
                                        <FormikTalentSearchAsCharacter
                                            disabled={disabled}
                                            name={name}
                                            index={idx}
                                            isMdmMode={isMdmSearchModeOn}
                                        />
                                    )}
                                </div>
                            )
                        })}
                    </>
                )}
            </FieldArray>
            {!disabled && !!values.portrays.length && (
                <MdmSearchModeCtrl
                    searchType={searchType}
                    isMdmIDOn={isMdmSearchModeOn}
                    onChange={onSearchModeChange}
                />
            )}
        </>
    )
}

export const InlineEditPortrays: React.FC<{
    disabled: boolean
}> = ({ disabled }) => {
    const { portrayalInEdit } = usePortrayalsContext()

    const searchType = useMemo(() => {
        return getPortraysSearchTypeFromPortrayalType(
            portrayalInEdit?.portrayal.portrayalType?.uri || '',
        )
    }, [portrayalInEdit])

    const selectList = useMemo(() => {
        return portrayalInEdit ? portrayalInEdit.portrays : []
    }, [portrayalInEdit])

    return (
        <>
            {selectList.map((_, idx) => {
                return (
                    <div
                        key={v4()}
                        style={{
                            marginBottom: idx === selectList.length - 1 ? 'auto' : '1rem',
                        }}
                    >
                        {searchType === SearchType.Character ? (
                            <InlineCharacterSearchAsCharacter disabled={disabled} index={idx} />
                        ) : (
                            <InlineTalentSearchAsCharacter disabled={disabled} index={idx} />
                        )}
                    </div>
                )
            })}
        </>
    )
}
